import Bannergiveaway from "components/common/Bannergiveaway";
import GiveawayListStatic from "components/common/GiveawayListStatic";

// Dashboard "giveaways" tab. The list itself (including the user's ticket
// entries, winner info and live-draw link) is rendered by the shared,
// dark-themed GiveawayListStatic component - see
// components/common/GiveawayListStatic. It detects it's running inside
// /dashboard and fetches the logged-in user's giveaways accordingly.
// The old implementation lives in index.backup.js / GiveawayCard.backup.js
// for reference.
function DashBoardGiveaways() {
    return (
        <>
            <Bannergiveaway />
            <GiveawayListStatic />
        </>
    );
}
export default DashBoardGiveaways;
